import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage415russian_test() {
        const page_seo = {
                    seo_title: 'russian-test - testprana.itpr.eu',
                    canonical: 'https:\/\/testprana.itpr.eu\/et\/rusisiabn-test',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: "019c89f4-e124-7ac0-8707-e0fa8224ccfd"
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[10417],"components":{"10417":{"id":10417,"uuid":"019c7a2d-45df-70a3-8c03-d6d95af055e7","language_id":null,"parent_id":null,"webpage_id":415,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"row","content_width_unit":"%","content_width_size":100,"styles":{"paddingTop":"60px","paddingLeft":"60px","paddingRight":"60px","paddingBottom":"60px"}},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}